import * as HelperSrc from "../HelperSrc";
import * as ModelAlert from "../model/Alert";

export default class StoreAlert {
    storageSet = (value: ModelAlert.Idata): void => {
        HelperSrc.writeStorage<ModelAlert.Idata>("alert", value);

        HelperSrc.storageDispatchEvent("alert");
    };

    storageGet = (): ModelAlert.Idata | undefined => {
        return HelperSrc.readStorage<ModelAlert.Idata>("alert");
    };

    storageRemove = (): void => {
        HelperSrc.removeStorage("alert");
    };
}
